<template>
    <div class="nio-image">
        <img :src="src" class="nio-image-pic" :class="{ 'loading': isImgLoading }" @load="onImgLoad" :alt="alt" v-if="!isNoneImg">
    </div>
</template>



<script>
export default {
    components: {},
    props: {
        src: String,
        alt: {
            type: String,
            default: '蔚来汽车'
        },
        isNoneImg: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isImgLoading: true
        };
    },
    computed: {},
    mounted() {},
    methods: {
        onImgLoad() {
            this.isImgLoading = false;
            // eslint-disable-next-line
            this.$emit('onLoad');
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/marketing_components/img-loader.vue